import { buildQueryString, fetch, handleErrors } from '../utils/apiUtils';

class TaskService {

  static getTasks(params) {

    let queryString = buildQueryString(params);

    return fetch(`${process.env.REACT_APP_API_URL}/api/tasks?${queryString}`)
      .then(resp => resp.json())
      .then(resp => {
        return {
          totalCount: resp.meta.totalResults,
          items: resp.data
        }
      });
  }

  static updateTask(task) {

    return fetch(`${process.env.REACT_APP_API_URL}/api/tasks/${task.id}`, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ data: task })
    }).then(handleErrors);
  }

  static createTask(task) {

    return fetch(`${process.env.REACT_APP_API_URL}/api/tasks`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ data: task })
    }).then(resp => resp.json());
  }

  static deleteTask(id) {

    return fetch(`${process.env.REACT_APP_API_URL}/api/tasks/${id}`, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    });
  }

  static updateAssignment(data) {

    return fetch(`${process.env.REACT_APP_API_URL}/api/tasks/me/assignments`, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...data })
    }).then(handleErrors);
  }

  static completeTask(data) {

    const { id, ...rest } = data;

    return fetch(`${process.env.REACT_APP_API_URL}/api/tasks/${id}/complete`, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(rest)
    }).then(handleErrors);
  }
}

export default TaskService;



// WEBPACK FOOTER //
// ./src/services/TaskService.js